import { ComponentProps } from 'react';
import {
  FormattedMessage,
  MessageDescriptor,
  defineMessages,
} from 'react-intl';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { PoweredByRotowire } from '@sorare/core/src/components/rotowire/PoweredByRotowire';

import { ProjectionScoreIcon } from 'searchCommonPlayer/StatsManager/Projections/ProjectionScoreIcon';

export type Projection = So5FixtureEvent.CLASSIC | So5FixtureEvent.DAILY;

const tooltipMessages: Record<Projection, MessageDescriptor> =
  defineMessages<Projection>({
    [So5FixtureEvent.DAILY]: {
      id: 'projection.tooltipMessages.daily',
      defaultMessage: 'Next Daily projection {rotowireLogo}',
    },
    [So5FixtureEvent.CLASSIC]: {
      id: 'projection.tooltip.classic',
      defaultMessage: 'Next Gameweek projection {rotowireLogo}',
    },
  });

type Props = {
  mode: Projection;
  color?: ComponentProps<typeof LabelS>['color'];
};

export const ProjectionLabel = ({ mode }: Props) => {
  return (
    <Tooltip
      title={
        <LabelS className="text-center">
          <FormattedMessage
            {...tooltipMessages[mode]}
            values={{ rotowireLogo: <PoweredByRotowire /> }}
          />
        </LabelS>
      }
    >
      <ProjectionScoreIcon so5FixtureEvent={mode} />
    </Tooltip>
  );
};
